import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@ui/components/Button'
import { ContentBlock } from '@ui/components/ContentBlock/ContentBlock'
import { FeatureIcon } from '@ui/components/FeatureIcon/FeatureIcon'
import { CircleCloseIcon } from '@ui/icons/CircleClose.icon'

import { useFundingExit } from '@hooks/useFundingExit'

import { Box } from '@shared/components/Box'
import { FullScreenFooter } from '@shared/templates/FullScreenLayout'
import { FundingTemplate } from '@shared/templates/FundingTemplate'

export const WithdrawalFailedContent: React.FC<{
  onTryAgain: () => void
}> = ({ onTryAgain }) => {
  const { t } = useTranslation()
  const { handleExit } = useFundingExit()
  const contentRef = useRef<HTMLDivElement>(null)

  return (
    <FundingTemplate contentRef={contentRef} onExit={handleExit}>
      <Box flex direction='column' gap='x32' fullWidth align='center' minHeight='100%'>
        <ContentBlock
          variant='voucher'
          icon={
            <FeatureIcon
              size='lg'
              icon={CircleCloseIcon}
              bg='surface-danger-high-em'
              color='text-white'
            />
          }
          title={t('Withdrawal Error')}
          description={t(
            'There was an issue submitting your withdrawal request. Please try again.'
          )}
        />
        <FullScreenFooter contentRef={contentRef}>
          <Button.Primary fullWidth size='lg' onClick={onTryAgain}>
            {t('Try again')}
          </Button.Primary>
        </FullScreenFooter>
      </Box>
    </FundingTemplate>
  )
}
